'use client';

import type { MrMapSummary } from './runtime/net/mysteryRoomApi';
import type { MysteryRoomGameMode, MysteryRoomMapDefinition } from './runtime/world/mapTypes';

/** Все режимы лобби (порядок совпадает с UI). */
export const MYSTERY_ROOM_ALL_GAME_MODES: MysteryRoomGameMode[] = ['coop', 'survival', 'stealth', 'infection'];

const MODE_SET = new Set<string>(MYSTERY_ROOM_ALL_GAME_MODES);

function normalizeModesList(raw: unknown): MysteryRoomGameMode[] | null {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const out: MysteryRoomGameMode[] = [];
  for (const item of raw) {
    const s = typeof item === 'string' ? item : '';
    if (MODE_SET.has(s) && !out.includes(s as MysteryRoomGameMode)) {
      out.push(s as MysteryRoomGameMode);
    }
  }
  return out.length ? out : null;
}

/** Непустой список режимов или null = карта доступна во всех режимах (обратная совместимость). */
export function getMysteryRoomMapPlayableModes(map: {
  playableGameModes?: MysteryRoomGameMode[] | null;
}): MysteryRoomGameMode[] | null {
  return normalizeModesList(map.playableGameModes);
}

export function mysteryRoomMapSupportsGameMode(
  map: MysteryRoomMapDefinition | MrMapSummary,
  mode: MysteryRoomGameMode,
): boolean {
  const limited = getMysteryRoomMapPlayableModes(map);
  if (!limited) return true;
  return limited.includes(mode);
}

export function formatMysteryRoomPlayableModesShort(map: {
  playableGameModes?: MysteryRoomGameMode[] | null;
}): string {
  const limited = getMysteryRoomMapPlayableModes(map);
  if (!limited) return 'Все режимы';
  if (limited.length === MYSTERY_ROOM_ALL_GAME_MODES.length) return 'Все режимы';
  const labels: Record<MysteryRoomGameMode, string> = {
    coop: 'Кооп',
    survival: 'Выживание',
    stealth: 'Скрытность',
    infection: 'Заражение',
  };
  return limited.map((m) => labels[m]).join(', ');
}
